'use client'

import dynamic from "next/dynamic";
import { useTournament } from '@/hooks/useTournament';

const ChartsGraphics = dynamic(() => import('@/components/charts'), { ssr: false });

export default function ChartsPage() {
  const savedTournament = useTournament();

  if (!savedTournament) return null;

  return (
    <div className="ipl-2021-charts">
      <ChartsGraphics savedTournament={savedTournament} />
    </div>
  );
}
